import { Switch } from 'antd';
import React from 'react';
import { LayerInfo } from '../../map_types';
import { CustomLayersButton } from './custom_layers_button';
import styles from './layer_card.less';

interface LayerCardButtonProps {
  checked: boolean;
  isComingSoon?: boolean;
  isLocked?: boolean;
  layer: LayerInfo;
  onSelect: () => void;
  useButton?: boolean;
}
export const LayerCardButton = (props: LayerCardButtonProps) => {
  const { checked, layer, onSelect, useButton, isLocked, isComingSoon } = props;

  if (isComingSoon) {
    return (
      <span className={styles.comingSoon}>
        Coming
        <br />
        Soon
      </span>
    );
  }

  return (
    <span className={styles.toggle}>
      {useButton ? (
        <CustomLayersButton
          isSelected={checked}
          onSelect={onSelect}
          isDisabled={isLocked}
          layer={layer}
        />
      ) : (
        <Switch checked={checked} onChange={onSelect} />
      )}
      {isLocked && (
        <span className={styles.proButtonOverlay} onClick={onSelect}>
          PRO
        </span>
      )}
    </span>
  );
};
